'use client';
import { BlockComponentModel } from '@/cms/types/blok-component';

import { BlockWrapper } from '@/cms/BlockWrapperDC';
import { CaptureUserDetailsProps } from '@/components/organisms/GatedContent/types';
import { SubmissionStatusMessage } from '@/components/organisms/SubmissionStatusPopUp';
import { SECTION_NAMES } from '@/integrations/trackingScripts/constants';
import { useState } from 'react';
import { LeadCollectionForm } from '.';
import { cn } from '@/lib/utils';
import { rainbowWaveBGStyle } from '@/constant/urls';

export interface LeadCollectionFormStrapiProps {
  lead_pop_up: {
    data: {
      attributes: CaptureUserDetailsProps;
    };
  };
}

export const LeadCollectionFormStrapi = ({
  block,
}: BlockComponentModel<LeadCollectionFormStrapiProps>) => {
  const leadPopUpData = block.lead_pop_up?.data?.attributes;

  const [submitState, setSubmitState] = useState<
    'idle' | 'success' | 'invalid' | 'error'
  >('idle');

  const handleSubmitResult = (result: 'success' | 'invalid' | 'error') => {
    setSubmitState(result);
    setTimeout(() => setSubmitState('idle'), 4000);
  };

  return (
    <div className='bg-gray-25 relative flex items-center justify-center bg-cover bg-center p-5 py-8 md:px-10 md:py-10'>
      <SubmissionStatusMessage
        status={submitState}
        onClose={() => setSubmitState('idle')}
      />
      <div
        className={cn(
          'absolute inset-0 hidden h-full w-full bg-cover bg-fixed bg-center bg-no-repeat md:block',
          rainbowWaveBGStyle
        )}
      />

      <BlockWrapper
        data-tracker-section={SECTION_NAMES.LEAD_COLLECTION_FORM}
        classNames={{
          root: 'relative z-10 w-full !p-0 max-w-[1360px] mx-auto md:bg-gray-25/50 md:backdrop-blur-[4px] rounded',
        }}
      >
        <LeadCollectionForm
          captureUserDetailsProps={leadPopUpData}
          onSubmitResult={handleSubmitResult}
        />
      </BlockWrapper>
    </div>
  );
};
